import React from "react";
import { Controller } from "react-hook-form";
import FIlterSelect from "../filter-select";
import Input from "../input";
import PhoneNumberInput from "../phone-input";

interface Details {
  accountType: string;
  setAccountType: any;
  control: any;
  clearErrors: any;
  errors: any;
  customer?: any;
}

const CustomerDetails: React.FC<Details> = ({
  accountType,
  setAccountType,
  control,
  customer,
}) => {
  return (
    <>
      <div className="items-center gap-4 mt-5">
        <Controller
          name="accountType"
          control={control}
          defaultValue="b2c"
          render={({ field }) => (
            <FIlterSelect
              name="accountType"
              options={[
                { value: "b2c", label: "B2C" },
                { value: "b2b", label: "B2B" },
                { value: "horeca", label: "HORECA" },
              ]}
              className="w-full"
              label="Account Type"
              onChange={(selectedValue) => {
                field.onChange(selectedValue);
                setAccountType(selectedValue);
              }}
              value={field.value}
            />
          )}
        />
      </div>

      {/* b2c Fields */}

      {accountType === "b2c" && (
        <div className="items-center gap-4 mt-4">
          <Controller
            name="contactName"
            control={control}
            defaultValue={customer?.contactName}
            rules={{
              required: "Full Name is required",
            }}
            render={({ field, fieldState }) => (
              <Input
                value={field.value}
                className="w-full"
                label="Full Name"
                placeholder="Enter Full Name"
                error={fieldState?.error?.message}
                onChange={field.onChange}
                autoComplete="off"
              />
            )}
          />
        </div>
      )}

      {/* b2b Fields */}
      {accountType === "b2b" && (
        <>
          <div className="items-center gap-4 mt-4">
            <Controller
              name="businessName"
              defaultValue={customer?.businessName}
              control={control}
              rules={{
                required: "Business Name is required",
              }}
              render={({ field, fieldState }) => (
                <Input
                  value={field.value}
                  className="w-full"
                  label="Business Name"
                  placeholder="Enter Business Name"
                  error={fieldState?.error?.message}
                  onChange={field.onChange}
                  autoComplete="off"
                />
              )}
            />
          </div>

          <div className="items-center gap-4 mt-4">
            <Controller
              name="businessType"
              defaultValue={customer?.businessType}
              control={control}
              rules={{
                required: "Business Type is required",
              }}
              render={({ field }) => (
                <FIlterSelect
                  name="businessType"
                  options={[
                    { value: "retail", label: "Retailer" },
                    { value: "wholesale", label: "Wholesaler" },
                    { value: "horeca", label: "HORECA" },
                  ]}
                  className="w-full"
                  label="Business Type"
                  onChange={field.onChange}
                  value={field.value}
                />
              )}
            />
          </div>

          <div className="items-center gap-4 mt-4">
            <Controller
              name="contactName"
              defaultValue={customer?.contactName}
              control={control}
              rules={{
                required: "Contact Person is required",
              }}
              render={({ field, fieldState }) => (
                <Input
                  value={field.value}
                  className="w-full"
                  label="Contact Person"
                  placeholder="Enter Contact Person"
                  error={fieldState?.error?.message}
                  onChange={field.onChange}
                  autoComplete="off"
                />
              )}
            />
          </div>

          <div className="items-center gap-4 mt-4">
            <Controller
              name="creditType"
              defaultValue={customer?.creditType}
              control={control}
              rules={{
                required: "Credit Type is required",
              }}
              render={({ field }) => (
                <FIlterSelect
                  name="creditStatus"
                  options={[
                    { value: "instant", label: "Instant" },
                    { value: "credit", label: "Credit" },
                  ]}
                  className="w-full"
                  label="Credit Type"
                  onChange={field.onChange}
                  value={field.value}
                />
              )}
            />
          </div>
        </>
      )}

      {/* Common Fields */}
      <div className="items-center gap-4 mt-4">
        <Controller
          name="contactNumber"
          defaultValue={customer?.contactNumber}
          control={control}
          rules={{
            required: "Phone Number is required",
          }}
          render={({ field, fieldState }) => (
            <PhoneNumberInput
              value={field.value}
              label="Phone Number"
              className="w-full"
              placeholder="080XXXXXXXX"
              error={fieldState?.error?.message}
              onChange={field.onChange}
              autoComplete="off"
            />
          )}
        />
      </div>

      <div className="items-center gap-4 mt-4">
        <Controller
          name="email"
          control={control}
          defaultValue={customer?.email}
          rules={{
            required: "Email is required",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Enter a valid email.",
            },
          }}
          render={({ field, fieldState }) => (
            <Input
              label="Email"
              value={field.value}
              placeholder="Enter Email"
              className="w-full"
              error={fieldState?.error?.message}
              onChange={field.onChange}
              autoComplete="off"
            />
          )}
        />
      </div>

      <div className="items-center gap-4 mt-2">
        <label className="block text-sm font-medium mb-1">
          Delivery Address
        </label>
        <Controller
          name="street"
          defaultValue={customer?.street}
          control={control}
          rules={{
            required: "Street is required",
          }}
          render={({ field, fieldState }) => (
            <Input
              value={field.value}
              className="w-full mb-2"
              placeholder="Street"
              error={fieldState?.error?.message}
              onChange={field.onChange}
              autoComplete="off"
            />
          )}
        />

        <div className="flex gap-2">
          <Controller
            name="city"
            defaultValue={customer?.city}
            control={control}
            rules={{
              required: "City is required",
            }}
            render={({ field, fieldState }) => (
              <Input
                value={field.value}
                className="w-full"
                placeholder="City"
                error={fieldState?.error?.message}
                onChange={field.onChange}
                autoComplete="off"
              />
            )}
          />

          <Controller
            name="state"
            defaultValue={customer?.state}
            control={control}
            rules={{
              required: "State is required",
            }}
            render={({ field, fieldState }) => (
              <Input
                value={field.value}
                className="w-full"
                placeholder="State"
                error={fieldState?.error?.message}
                onChange={field.onChange}
                autoComplete="off"
              />
            )}
          />
        </div>
      </div>

      

    </>
  );
};

export default CustomerDetails;
